import {useCallback} from 'react';

import type {GetHealthEmergencyLink} from 'domain/usecases';
import {makeGetHealthEmergencyLink} from 'main/factories/usecases';
import {EmergencyTelehealthRoomUnavailableError} from 'presentation/components/EmergencyTelehealthUnavailableRoomModal/error';
import {isEmergencyTelehealthRoomUnavailable} from 'presentation/components/EmergencyTelehealthUnavailableRoomModal/isEmergencyTelehealthRoomUnavailable';
import {useEmergencyTelehealthUnavailableRoomModalStore} from 'presentation/components/EmergencyTelehealthUnavailableRoomModal/store';

import {useHostName} from '../useHostName';
import {useTelemedicineUrlUpdateFeature} from '../useTelemedicineUrlUpdateFeature';

export const useHealthEmergencyLinkFactory = () => {
	const {isClinipam} = useHostName();
	const onOpenUnavailableRoomModal = useEmergencyTelehealthUnavailableRoomModalStore(
		state => state.onOpen,
	);
	const {isEnabled: useV3} = useTelemedicineUrlUpdateFeature();

	return useCallback((): GetHealthEmergencyLink => {
		const healthEmergencyLink = makeGetHealthEmergencyLink(useV3);

		return {
			get: async params => {
				const room = await healthEmergencyLink.get(params);

				if (isEmergencyTelehealthRoomUnavailable(room, isClinipam)) {
					onOpenUnavailableRoomModal();
					throw new EmergencyTelehealthRoomUnavailableError();
				}

				return room;
			},
		};
	}, [isClinipam, onOpenUnavailableRoomModal, useV3]);
};
